// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PnASO","header":"styles_header__BwT0i","middle":"styles_middle__3Lcx6","member":"styles_member__xzSMK"};